<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/COXUUj/tc-custom/9780544279230.jpg?1700311819548" alt="This image is the cover for the book Pedro"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pedro
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The <i>New York Times</i>–bestselling memoir from the legendary, former Boston Red Sox pitcher.</b><br/><br/> Pedro Martinez entered the big leagues a scrawny power pitcher with a lightning arm who they said wasn’t “durable” enough, who they said was a punk. Yet Martinez willed himself to become one of the most intimidating pitchers to have ever played the game, an eight-time All-Star, three-time Cy Young Award winner, World Series champion, and Hall of Famer.<br/>  <br/> In <i>Pedro</i>, the always colorful pitcher opens up to tell his remarkable story. From his days in the minor leagues clawing for respect; to his early days in lonely Montreal; to his legendary run with the Red Sox when, start after start, he dazzled with his pitching genius; to his twilight years on the mound as he put the finishing touches on a body of work that made him an icon, this memoir by one of baseball’s most enigmatic figures will entertain and inspire generations of fans to come.</p><p><br/><b>“<i>Pedro</i> the book is as smart, as funny, and as diva-esque as Pedro the pitcher…Buy the book. Read the book. Celebrate a golden era in Boston baseball.” — <i>Boston Globe</i><br/><br/> “There is little the eight-time All-Star holds back about any subject as he offers a revealing look at a colorful career…The intimate details Martinez offers up from both inside and outside the clubhouse make the book a winner.”—<i>Washington Post</i></b></p><b>“This is the beauty of this book, the machinations of a modern pitcher's mind…Knowing and gritty, this memoir should’ve been printed on rawhide.”—<i>Los Angeles Times</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pedro Martinez, Michael Silverman
      </h2>
      
      <p class="authorDescription body article">PEDRO MARTINEZ is a former Major League Baseball pitcher. An eight-time All-Star, three-time Cy Young Award winner, and 2004 World Series champion, Martinez was elected to the Hall of Fame in his first year of eligibility and is a special consultant for the Boston Red Sox.MICHAEL SILVERMAN is a baseball columnist for the Boston Herald and has been covering baseball and the Red Sox since 1995.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?efd507e8